import ModalStack from '@/components/Custom/ModalStack';

export default function PrivateEventEventIdEventsActionLayoutRoute() {
  return <ModalStack />;
}
